import {countriesWithoutStates, googleStateNamesToSFDC} from './settings';

export const getCityFromRawPlace = function(rawPlace) {
    /*
        When Google returns null for locality property, search for postal_town
        type in raw response. This returns the city in countries like United Kingdom
    */
    for (let addressComponent of rawPlace.address_components) {
        if (addressComponent.types.includes("postal_town")) {
            return addressComponent.long_name || addressComponent.short_name || null;
        }
    }
    return null;
}

export const setState = function(country, place) {
    if (!countriesWithoutStates.includes(country.toLowerCase())) {
        return googleStateNamesToSFDC[place.administrative_area_level_1] || place.administrative_area_level_1 || "";
    } else {
        return "";
    }
}
